<script setup lang='ts'>
import type { SpinnerColor, SpinnerPosition, SpinnerSize } from '~/constants/spinner'
import { KsSpinner } from '@aschehoug/kloss'

withDefaults(defineProps<{
  size?: SpinnerSize
  position?: SpinnerPosition
  color?: SpinnerColor
}>(), {
  size: 'small',
  position: 'inline',
  color: 'blurple',
})
</script>

<template>
  <KsSpinner :size="size" :position="position" :class="color" />
</template>

<style scoped lang='postcss'>
.ks-spinner {
  :deep(div) {
    @apply border-4 rounded-full;
  }

  &.blurple {
    :deep(div) {
      @apply border-blurple-300 border-r-transparent;
    }
  }

  &.moss {
    :deep(div) {
      @apply border-moss-300 border-r-transparent;
    }
  }

  &.carbon {
    :deep(div) {
      @apply border-carbon-300 border-r-transparent;
    }
  }
}

.ks-spinner-small {
  @apply w-10 h-10;

  :deep(div) {
    @apply border-[3px];
  }
}

.ks-spinner-medium {
  @apply w-20 h-20;
}

.ks-spinner-large {
  @apply w-40 h-40;
}
</style>
